// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-bordered > .panel-heading > .panel-title[data-v-ac50dee6] {\n  padding-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
